import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from '@redux-saga/core';
import rootSaga from '../saga/rootSaga';
import treeSlice from '../components/features/Tree/tree.slice';
import loginSlice from '../components/features/Login/login.slice';
import savedUserTokenSlice from '../components/features/Login/userSettingsSaveUserTokenToDB.slice';
import userProfileSlice from '../components/features/userProfile/userProfile.slice';
import projectsSlice from '../components/features/Projects/projects.slice';
import projectSlice from '../components/features/Projects/project.slice';
import logoutSlice from '../components/features/Logout/logout.slice';
import stagingSlice from '../components/features/Dashboard/DashboardStaging/staging.slice';
import stagingIdSlice from '../components/features/Dashboard/DashboardStaging/stagingId.slice';
import stagingItemSlice from '../components/features/Dashboard/DashboardStaging/stagingItem.slice';
import movingSlice from '../components/features/MergingMove/merging.slice';
import addingSlice from '../components/features/MergingMove/moving.slice';
import stagingDeleteAvatarSlice from '../components/features/Dashboard/DashboardStaging/stagingDeleteAvatar.slice';
import stagingDeletedAvatarsIdSlice from '../components/features/Dashboard/DashboardStaging/stagingDeletedAvatarsId.slice';
import nodeInfoSlice from '../components/features/Tree/nodeInfo.slice';
import downloadSlice from '../components/features/LauncherConfiguration/Download/download.slice';
import featuresSlice from '../components/features/LauncherConfiguration/Features/features.slice';
import modalSlice from '../components/features/Modal/modal.slice';
import filterOnOffSlice from '../components/features/LauncherConfiguration/Features/filterOnOff.slice';
import toolTipSlice from '../components/features/ToolTip/toolTip.slice';
import getAllChildrensPerNodeSlice from '../components/features/LauncherConfiguration/Features/getAllChildrensPerNode.slice';
import treeNodeSelectedSlice from '../components/features/TreeComposite/TreeWidget/treeNodeSelected.slice';
import genericRadioBtnSlice from '../components/features/TreeComposite/TreeWidget/genericRadioBtn.slice';
import avatarTypeSlice from '../components/features/TreeComposite/TreeSettings/ProjectWindow/avatarType.slice';
import departmentNetworkSlice from '../components/features/Datamanager/ViewportDepartmentNetwork/departmentNetwork.slice';
import arangeDepartmentSlice from '../components/features/Datamanager/ViewportDepartmentNetwork/arangeDepartment.slice';
import websocketSlice from '../components/features/WebSocket/websocket.slice';
import loginNumbersSlice from '../components/features/Login/loginNumbers.slice';
import departmentsSlice from '../components/features/Datamanager/ViewportDepartmentNetwork/departments.slice';
import commitsSlice from '../components/features/Datamanager/Commits/commits.slice';
import statusSlice from '../components/features/Datamanager/Status/status.slice';
import chatBotResponseSlice from '../components/features/Chatbot/chatBotResponse.slice';
import chatBotHistorySlice from '../components/features/Chatbot/chatBotHistory.slice';
import triggerAnythingSlice from '../slices/triggerAnything';
import knowladgeGraphDiffSlice from '../components/features/Datamanager/Inspector/AiAnalyzer/KnowladgeGraphDiffTable/knowledgeGraphDiff.slice';
import orchestrationTriggerEtlSlice from '../components/features/Datamanager/Inspector/AiAnalyzer/Orchestrator/orchestratorTriggerEtl.slice';
import knowledgeGraphForSendingSlice from '../components/features/Datamanager/Inspector/AiAnalyzer/KnowladgeGraphDiffTable/knowledgeGraphDiffForSending.slice';
import knowledgeGraphSelectedButtonSlice from '../components/features/Datamanager/Inspector/AiAnalyzer/KnowladgeGraphDiffTable/knowledgeGraphSelectedButton.slice';
import knowledgeGraphMergeSlice from '../components/features/Datamanager/Inspector/AiAnalyzer/KnowledgeGraphMerge/knowledgeGraphMerge.slice';
import inFlowTransferSlice from '../components/features/Datamanager/Inspector/AiAnalyzer/InFlowTransfer/inFlowTransfer.slice';
import commitHistorySlice from '../components/features/Datamanager/CommitHistory/commitHistory.slice';
import sourceTargetDepartmentSlice from '../components/features/Datamanager/ViewportDepartmentNetwork/sourceTargetDepartment.slice';
import fileListSlice from '../components/features/Datamanager/Inspector/AiAnalyzer/BlobStorage/fileList.slice';
import radioBtnSlice from '../components/features/TreeComposite/TreeSettings/TreeSettingsRadioBtn/radioBtn.slice';
import allNodesSlice from '../components/features/TreeComposite/TreeWidget/allNodes.slice';
import websocketHostnameSlice from '../components/features/WebSocket/websocketHostname.slice';
import userSettingsFilePathSlice from '../components/features/UserSettings/FilePath/userSettingsAddFilePath.slice';
import userSettingsAllFilePathSlice from '../components/features/UserSettings/FilePath/userSettingsAllFilePaths.slice';
import allPathsSlice from '../components/features/UserSettings/FilePath/userSettingsFilePathFastChanging.slice';
import userSettingsAddProjectPathSlice from '../components/features/UserSettings/ProjectPath/userSettingsAddProjectPath.slice';
import userSettingsProjectPathSlice from '../components/features/UserSettings/ProjectPath/userSettingsProjectPath.slice';
import defaultProjectPathSlice from '../components/features/UserSettings/ProjectPath/userSettingsProjectPathFastChanging.slice';
import dashboardListDisplaySlice from '../components/features/Dashboard/DashboardList/dashboardListDisplay.slice';
import projectFeatureListFastUpdateSlice from '../components/features/ProjectAdminConfig/projectFeatureListFastUpdate.slice';
import projectFeatureListSlice from '../components/features/ProjectAdminConfig/ProjectFeatureList.slice';
import projectFeatureListPostSlice from '../components/features/ProjectAdminConfig/ProjectFeatureListPost.slice';
import dashboardNodeTypeSlice from '../components/features/Dashboard/DashboardList/DashboardNodeType.slice';
import dashboardStatusBarSlice from '../components/features/Dashboard/DashboardList/dashboardStatusBar.slice';
import createAndSendPassengersSlice from '../components/features/Datamanager/Inspector/AiAnalyzer/Analyzer/AyAnalyzerCreateAndSendPassengers.slice';
import dashboardDragAndDropSlice from '../components/features/Dashboard/DashboardDragAndDrop/dashboardDragAndDrop.slice';
import websocketScriptSettingsSlice from '../components/features/Datamanager/Inspector/ScriptSettings/scriptSettings.slice';
import scriptUpdateSlice from '../components/features/Datamanager/Inspector/ScriptSettings/scriptUpdate.slice';
import aiDataExtractorPackageDetailsSlice from '../components/features/AiDataExtractor/AiDataExtractorPackageDetails/aiDataExtractorPackageDetails.slice'


const saga = createSagaMiddleware();

export const store = configureStore({
    reducer: {
        projectDetails: treeSlice,
        loginUserAndTokenData: loginSlice,
        savedUserToken:savedUserTokenSlice,
        userDisplay: userProfileSlice,
        projects: projectsSlice,
        project: projectSlice,
        stagingId: stagingIdSlice,
        userLogout: logoutSlice,
        stagingList: stagingSlice,
        stagingItem: stagingItemSlice,
        mergingAvatar: movingSlice,
        movingAvatar: addingSlice,
        deleteAvatar: stagingDeleteAvatarSlice,
        deletedAvatarId: stagingDeletedAvatarsIdSlice,
        nodeInfo: nodeInfoSlice,
        louncherInstaller: downloadSlice,
        featuresConfig: featuresSlice,
        modal: modalSlice,
        featuresFilter: filterOnOffSlice,
        toolTip: toolTipSlice,
        filteredChildrenNodesPerSelection: getAllChildrensPerNodeSlice,
        projectNode: treeNodeSelectedSlice,
        avatarType: avatarTypeSlice,
        departmentNetwork: departmentNetworkSlice,
        arangeDepartments: arangeDepartmentSlice,
        webSocket: websocketSlice,
        loginNumbers: loginNumbersSlice,
        departments: departmentsSlice,
        commits: commitsSlice,
        status: statusSlice,
        trigger: triggerAnythingSlice,
        chat: chatBotResponseSlice,
        chatHistory: chatBotHistorySlice,
        knowladgeGraphDiff: knowladgeGraphDiffSlice,
        triggerEtl: orchestrationTriggerEtlSlice,
        knowledgeGraphForSending: knowledgeGraphForSendingSlice,
        knowledgeFile: knowledgeGraphSelectedButtonSlice,
        knowledgeGraphMerge: knowledgeGraphMergeSlice,
        inFlowTransfer: inFlowTransferSlice,
        commitHistory: commitHistorySlice,
        sourceTargetDepartment: sourceTargetDepartmentSlice,
        fileList: fileListSlice,
        treeSettingsRadioBtn: radioBtnSlice,
        allNodes: allNodesSlice,
        hostAndUsername: websocketHostnameSlice,
        userSettingsFilePath: userSettingsFilePathSlice,
        userSettingsAllFilePath: userSettingsAllFilePathSlice,
        userSettingsAddProjectPath: userSettingsAddProjectPathSlice,
        userSettingsProjectPath:userSettingsProjectPathSlice,
        allPaths: allPathsSlice,
        defaultProjectPath: defaultProjectPathSlice,
        dashboardListDisplay: dashboardListDisplaySlice,
        projectFeatureListFastUpdate: projectFeatureListFastUpdateSlice,
        projectFeatureList: projectFeatureListSlice,
        projectFeatureListPost: projectFeatureListPostSlice,
        dashboardNodeType: dashboardNodeTypeSlice,
        dashboardStatusBar: dashboardStatusBarSlice,
        createAndSendPassengers: createAndSendPassengersSlice,
        dashboardDragAndDrop: dashboardDragAndDropSlice,
        websocketScriptSettings: websocketScriptSettingsSlice,
        scriptUpdate: scriptUpdateSlice,
        genericRadioBtn: genericRadioBtnSlice,
        aiDataExtractorPackageDetails: aiDataExtractorPackageDetailsSlice
    },
    middleware: (defaultMiddleware) => defaultMiddleware().concat(saga),
});

saga.run(rootSaga);

export type rootState = ReturnType<typeof store.getState>;
export type appDispatch = typeof store.dispatch;
